<div class="popup-form wf-section">
  <button class="closedialog close-signuponly" (click)="closeDialog()">
    <i class="material-icons">close</i>
  </button>
  <div class="container">
    <div class="hero-title-center flex-inner">
      <div>
        <h2 class="hero-title _50px">
          <span class="add-scribble-below"> {{DialogueData.Title}}</span><br>
        </h2>

      </div>
    </div>
    <div class="margin-50px">
      <div class="w-form">
        {{DialogueData.Description}}
      </div>
    </div>
    <div class="margin-20px">
      <div class="pull-right">
        <a (click)="closeDialog()" class="button" style="cursor:pointer">OK</a>
      </div>
    </div>
    <br/>
  </div>
</div>
